// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 개선 전/후 비교 탭 — 머리말(판정) + 좌우 계획. */

.PlanCompare_compareRoot__wIVdU {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.PlanCompare_compareHeader__UdTqG {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 6px 10px;
  border-bottom: 1px solid var(--color-border, #e0e0e0);
  background: var(--color-bg-secondary, #f8f9fa);
  flex-shrink: 0;
}

.PlanCompare_verdict__nCh7u {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--color-text, #1f2937);
}
.PlanCompare_verdict__nCh7u code {
  padding: 1px 6px;
  border-radius: 3px;
  background: var(--color-bg-tertiary, #eceef1);
  font-family: 'Consolas', monospace;
}
.PlanCompare_sideLabel__iBWsO {
  font-size: 11px;
  color: var(--color-text-secondary, #6b7280);
}
.PlanCompare_arrow__copuk { color: var(--color-text-muted, #9ca3af); }

/* 줄어든 것이 좋은 것이다 — 색으로 방향을 말한다 */
.PlanCompare_delta__W7VTX {
  padding: 1px 7px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 600;
}
.PlanCompare_better__zl20m { background: #dcfce7; color: #166534; }
.PlanCompare_worse__KnALX { background: #fee2e2; color: #991b1b; }

.PlanCompare_metricNote__z65p0 {
  font-size: 10px;
  color: var(--color-text-muted, #9ca3af);
}

.PlanCompare_variants__ajhOp {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}
.PlanCompare_variantChip__V7HBH {
  padding: 2px 9px;
  border: 1px solid var(--color-border, #d0d5dd);
  border-radius: 10px;
  background: transparent;
  color: var(--color-text-secondary, #6b7280);
  font-size: 11px;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;
}
.PlanCompare_variantChip__V7HBH:hover { border-color: var(--color-accent, #3b82f6); }
.PlanCompare_variantOn__rn\\+rA {
  background: var(--color-accent, #3b82f6);
  border-color: var(--color-accent, #3b82f6);
  color: #fff;
}

.PlanCompare_saveBtn__dDYz9 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  padding: 3px 9px;
  border: 1px solid var(--color-border, #d0d5dd);
  border-radius: 3px;
  background: var(--color-bg, #fff);
  color: var(--color-text, #1f2937);
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;
}
.PlanCompare_saveBtn__dDYz9:hover { border-color: var(--color-accent, #3b82f6); color: var(--color-accent, #3b82f6); }

.PlanCompare_summary__V1SOY {
  padding: 5px 10px;
  font-size: 11px;
  line-height: 1.5;
  color: var(--color-text-secondary, #6b7280);
  border-bottom: 1px solid var(--color-border, #eee);
  flex-shrink: 0;
}

.PlanCompare_warnings__s49Iv {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  font-size: 11px;
  color: #92400e;
  background: #fffbeb;
  border-bottom: 1px solid #fde68a;
  flex-shrink: 0;
}

.PlanCompare_panes__WzeUD {
  flex: 1 1;
  min-height: 0;
  display: flex;
}
.PlanCompare_panes__WzeUD > * { flex: 1 1; min-width: 0; }

[data-theme="dark"] .PlanCompare_compareHeader__UdTqG {
  background: var(--color-bg-tertiary);
  border-bottom-color: var(--color-border);
}
[data-theme="dark"] .PlanCompare_saveBtn__dDYz9 {
  background: transparent;
  color: var(--color-text);
  border-color: var(--color-border);
}
[data-theme="dark"] .PlanCompare_better__zl20m { background: #14532d; color: #bbf7d0; }
[data-theme="dark"] .PlanCompare_worse__KnALX { background: #7f1d1d; color: #fecaca; }
[data-theme="dark"] .PlanCompare_warnings__s49Iv { background: #3a2a00; color: #ffc107; border-bottom-color: #665500; }

@media (prefers-reduced-motion: reduce) {
  .PlanCompare_variantChip__V7HBH, .PlanCompare_saveBtn__dDYz9 { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/PlanCompare.module.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,qDAAqD;EACrD,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,2CAA2C;AAC7C;AACA,4BAAS,uCAAuC,EAAE;;AAElD,gCAAgC;AAChC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA,6BAAU,mBAAmB,EAAE,cAAc,EAAE;AAC/C,4BAAS,mBAAmB,EAAE,cAAc,EAAE;;AAE9C;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;EACf,eAAe;EACf,4EAA4E;AAC9E;AACA,wCAAqB,0CAA0C,EAAE;AACjE;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;AACA,oCAAiB,0CAA0C,EAAE,mCAAmC,EAAE;;AAElG;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;AACf;AACA,gCAAa,SAAO,EAAE,YAAY,EAAE;;AAEpC;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;AACnC;AACA,iDAAuC,mBAAmB,EAAE,cAAc,EAAE;AAC5E,gDAAsC,mBAAmB,EAAE,cAAc,EAAE;AAC3E,mDAAyC,mBAAmB,EAAE,cAAc,EAAE,4BAA4B,EAAE;;AAE5G;EACE,+DAAyB,gBAAgB,EAAE;AAC7C","sourcesContent":["/* 개선 전/후 비교 탭 — 머리말(판정) + 좌우 계획. */\n\n.compareRoot {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.compareHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding: 6px 10px;\n  border-bottom: 1px solid var(--color-border, #e0e0e0);\n  background: var(--color-bg-secondary, #f8f9fa);\n  flex-shrink: 0;\n}\n\n.verdict {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--color-text, #1f2937);\n}\n.verdict code {\n  padding: 1px 6px;\n  border-radius: 3px;\n  background: var(--color-bg-tertiary, #eceef1);\n  font-family: 'Consolas', monospace;\n}\n.sideLabel {\n  font-size: 11px;\n  color: var(--color-text-secondary, #6b7280);\n}\n.arrow { color: var(--color-text-muted, #9ca3af); }\n\n/* 줄어든 것이 좋은 것이다 — 색으로 방향을 말한다 */\n.delta {\n  padding: 1px 7px;\n  border-radius: 9px;\n  font-size: 11px;\n  font-weight: 600;\n}\n.better { background: #dcfce7; color: #166534; }\n.worse { background: #fee2e2; color: #991b1b; }\n\n.metricNote {\n  font-size: 10px;\n  color: var(--color-text-muted, #9ca3af);\n}\n\n.variants {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n.variantChip {\n  padding: 2px 9px;\n  border: 1px solid var(--color-border, #d0d5dd);\n  border-radius: 10px;\n  background: transparent;\n  color: var(--color-text-secondary, #6b7280);\n  font-size: 11px;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n.variantChip:hover { border-color: var(--color-accent, #3b82f6); }\n.variantOn {\n  background: var(--color-accent, #3b82f6);\n  border-color: var(--color-accent, #3b82f6);\n  color: #fff;\n}\n\n.saveBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: auto;\n  padding: 3px 9px;\n  border: 1px solid var(--color-border, #d0d5dd);\n  border-radius: 3px;\n  background: var(--color-bg, #fff);\n  color: var(--color-text, #1f2937);\n  font-size: 11px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n.saveBtn:hover { border-color: var(--color-accent, #3b82f6); color: var(--color-accent, #3b82f6); }\n\n.summary {\n  padding: 5px 10px;\n  font-size: 11px;\n  line-height: 1.5;\n  color: var(--color-text-secondary, #6b7280);\n  border-bottom: 1px solid var(--color-border, #eee);\n  flex-shrink: 0;\n}\n\n.warnings {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  font-size: 11px;\n  color: #92400e;\n  background: #fffbeb;\n  border-bottom: 1px solid #fde68a;\n  flex-shrink: 0;\n}\n\n.panes {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n}\n.panes > * { flex: 1; min-width: 0; }\n\n:global([data-theme=\"dark\"]) .compareHeader {\n  background: var(--color-bg-tertiary);\n  border-bottom-color: var(--color-border);\n}\n:global([data-theme=\"dark\"]) .saveBtn {\n  background: transparent;\n  color: var(--color-text);\n  border-color: var(--color-border);\n}\n:global([data-theme=\"dark\"]) .better { background: #14532d; color: #bbf7d0; }\n:global([data-theme=\"dark\"]) .worse { background: #7f1d1d; color: #fecaca; }\n:global([data-theme=\"dark\"]) .warnings { background: #3a2a00; color: #ffc107; border-bottom-color: #665500; }\n\n@media (prefers-reduced-motion: reduce) {\n  .variantChip, .saveBtn { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"compareRoot": `PlanCompare_compareRoot__wIVdU`,
	"compareHeader": `PlanCompare_compareHeader__UdTqG`,
	"verdict": `PlanCompare_verdict__nCh7u`,
	"sideLabel": `PlanCompare_sideLabel__iBWsO`,
	"arrow": `PlanCompare_arrow__copuk`,
	"delta": `PlanCompare_delta__W7VTX`,
	"better": `PlanCompare_better__zl20m`,
	"worse": `PlanCompare_worse__KnALX`,
	"metricNote": `PlanCompare_metricNote__z65p0`,
	"variants": `PlanCompare_variants__ajhOp`,
	"variantChip": `PlanCompare_variantChip__V7HBH`,
	"variantOn": `PlanCompare_variantOn__rn+rA`,
	"saveBtn": `PlanCompare_saveBtn__dDYz9`,
	"summary": `PlanCompare_summary__V1SOY`,
	"warnings": `PlanCompare_warnings__s49Iv`,
	"panes": `PlanCompare_panes__WzeUD`
};
export default ___CSS_LOADER_EXPORT___;
